import React, { useState, useEffect } from "react";
import { Section, Container } from "../../common/UI";
import TechMatrix from "./TechMatrix";
import { getSkillsAndTechnologies } from "../../../services/contentful";

const Skills = () => {
  const [skills, setSkills] = useState([]);
  const [technologies, setTechnologies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadSkillsAndTech = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const { skills: fetchedSkills, technologies: fetchedTechnologies } = 
          await getSkillsAndTechnologies();
        
        setSkills(fetchedSkills);
        setTechnologies(fetchedTechnologies);
      } catch (err) {
        console.error("Error loading skills and technologies:", err);
        setError("Failed to load skills and technologies");
      } finally {
        setLoading(false);
      }
    };

    loadSkillsAndTech();
  }, []);

  // Show error state if needed
  if (error && !loading) {
    return (
      <Section id="skills" background="alt" padding="default">
        <Container>
          <div className="text-center py-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
              Technical Skills
            </h2>
            <p className="text-xl text-red-600 dark:text-red-400">
              {error}
            </p>
            <p className="text-gray-600 dark:text-gray-400 mt-2">
              Please check your Contentful configuration or try refreshing the page.
            </p>
          </div>
        </Container>
      </Section>
    );
  }

  return (
    <Section id="skills" background="alt" padding="default">
      <Container>
        <TechMatrix 
          skills={skills}
          technologies={technologies}
          loading={loading}
        />
      </Container>
    </Section>
  );
};

export default Skills;